import styled from "@emotion/styled";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";

import { Breakpoints, mq } from "../../helpers/mediaQuery";
import { gotToPricing } from "../../helpers/redirects";
import { Actions } from "./Modals/DefaultModal";

const LimitedAccess = styled((props) => {
	const { t } = useTranslation();

	return (
		<div className={props.className}>
			<div>
				<h3>{t("modals.limitedAccess.header")}</h3>
				<p>{t("modals.limitedAccess.subheader")}</p>
				<Actions>
					<Button variant="contained" onClick={gotToPricing}>
						{t("modals.limitedAccess.primary")}
					</Button>
				</Actions>
			</div>
		</div>
	);
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  height: 100%;

  > div {
    border-radius: 12px;
    width: 100%;
    aspect-ratio: 1.5/1;
    max-width: 80%;
    padding: 24px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    > p {
      margin: 0;
      font-size: 14px;
      color: #9e9e9e;
    }

    > svg {
      width: 160px;
    }

    > h3 {
      margin-bottom: 8px;
    }
  }

  ${mq(Breakpoints.sm)} {
    justify-content: center;
    > div {
      background: unset;
      max-width: unset;
      aspect-ratio: unset;
    }
  }
`;

export default LimitedAccess;
export const ShortLimitedAccess = styled(LimitedAccess)`
  > div {
    aspect-ratio: unset;
    max-width: unset;
  }

  svg {
    display: none;
  }
`;
